module.exports = __webpack_public_path__ + "img/mindmaster_freieradikale.fe241908.jpg";